import React from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';

import Dialog from '../../shared/PFDialog/PFDialogContainer';
import { FeatureObject } from '../../Admin/HelpPageConfig/interface/features.interface';
import { STATUS_OPTIONS } from '../../Admin/HelpPageConfig/constants/features.constant';

import { fetchFeatureDataByModule } from './pageHeader.service';

import '../../UserGuide/styles/userGuide.styles.css';

const PageFeature: React.FC<{
  identifier: string;
}> = ({ identifier }) => {
  const overlayPanelRef = React.createRef<OverlayPanel>();
  const [featureData, setFeatureData] = React.useState<FeatureObject[]>();
  const [visible, setVisible] = React.useState<boolean>(false);

  React.useEffect(() => {
    const fetchFeatureData = async () => {
      try {
        const response = await fetchFeatureDataByModule(identifier);
        if (response && !response.error) {
          setFeatureData(response.data);
        }
      } catch (error) {
        console.error('Failed to fetch feature data:', error);
      }
    };

    fetchFeatureData();
  }, []);
  function decodeHtmlEntities(html?: string) {
    const txt = document.createElement('textarea');
    txt.innerHTML = html || '';
    return txt.value;
  }
  return (
    <>
      {featureData?.length ? (
        <Button
          icon="pi pi-question-circle text-xl"
          size="small"
          className="h-2rem w-2rem focus:shadow-none p-0 justify-content-center -ml-1"
          text
          onClick={event => overlayPanelRef?.current?.toggle(event)}
        />
      ) : null}
      <OverlayPanel ref={overlayPanelRef} className="w-4">
        <span className="flex align-items-center gap-2">
          <i className="pi pi-sparkles text-sm text-primary" />
          <span
            className="text-sm ellipsis text-primary"
            title={featureData?.[0]?.feature_name}
          >
            {featureData?.[0]?.feature_name}
          </span>
        </span>
        <div className="flex gap-2 flex-column">
          <span
            className="text-xs summary-ellipsis"
            title={featureData?.[0]?.summary}
          >
            {featureData?.[0]?.summary}
          </span>
          <div className="flex gap-2 pt-4">
            {featureData?.[0]?.description && (
              <Button
                icon="pi pi-exclamation-circle"
                outlined
                size="small"
                label="Learn More"
                type="button"
                onClick={() => setVisible(true)}
                pt={{
                  icon: { className: 'text-color' },
                  label: {
                    className: 'text-xs font-bold',
                  },
                }}
                className="border-500 py-1 border-2 rounded-lg shadow-sm transition-transform hover:scale-110"
              />
            )}
            <Dialog
              header={
                <div className="flex flex-column gap-2">
                  <div className="flex align-items-center gap-2">
                    <i className="pi pi-lightbulb text-blue-600 text-base" />
                    <span
                      className="text-blue-600 text-base font-bold summary-ellipsis"
                      data-pr-tooltip={featureData?.[0]?.feature_name}
                      data-pr-position="bottom"
                    >
                      {featureData?.[0]?.feature_name}
                    </span>
                    <Tooltip
                      target=".summary-ellipsis"
                      style={{ fontSize: '0.75rem' }}
                    />
                  </div>
                  <div
                    className="text-sm text-bluegray-500 font-normal summary-ellipsis"
                    style={{
                      whiteSpace: 'normal',
                      overflowWrap: 'break-word',
                      wordBreak: 'break-word',
                    }}
                    data-pr-tooltip={featureData?.[0]?.summary}
                    data-pr-position="bottom"
                  >
                    {featureData?.[0]?.summary}
                  </div>
                  <Tooltip
                    target=".summary-ellipsis"
                    style={{ fontSize: '0.75rem' }}
                  />
                </div>
              }
              visible={visible}
              style={{ width: '50vw' }}
              onHide={() => {
                if (visible === false) return;
                setVisible(false);
              }}
            >
              <>
                <div className="text-sm font-bold">Detailed Description:</div>
                <div
                  className="text-sm text-gray-700"
                  style={{
                    whiteSpace: 'normal',
                    overflowWrap: 'break-word',
                    wordBreak: 'break-word',
                  }}
                  dangerouslySetInnerHTML={{
                    __html: decodeHtmlEntities(featureData?.[0]?.description),
                  }}
                ></div>
              </>
            </Dialog>
            {featureData?.[0]?.youtube_url && (
              <Button
                icon="pi pi-youtube"
                size="small"
                label="Watch Video"
                pt={{
                  icon: { className: 'text-red-500' },
                  label: {
                    className: 'text-red-500 text-xs font-bold',
                  },
                }}
                className="border-red-500 py-1 border-2 rounded-lg shadow-sm hover:bg-red-100 transition-transform hover:scale-110"
                type="button"
                tooltip={featureData?.[0]?.youtube_url}
                data-pr-position="bottom"
                data-pr-classname="text-sm"
                onClick={() =>
                  window.open(featureData?.[0]?.youtube_url, '_blank')
                }
                outlined
                aria-label="Watch feature video on YouTube"
              />
            )}
          </div>
        </div>
        {featureData?.[0]?.type ? (
          <span className="absolute top-0 right-0 bg-green-500 text-white text-xs px-2 py-1">
            {
              STATUS_OPTIONS?.find(
                status => status.value === featureData?.[0].type
              )?.label
            }
          </span>
        ) : null}
      </OverlayPanel>
    </>
  );
};

export default PageFeature;
